<template>
  <el-dialog
    :title="dialogTitle"
    :visible="true"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="() => handleClose(false, form.infoContent)"
  >
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="标题" required>
        <QuillEditor2 :maxlength="65" v-model="form.title" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="宣传介绍图" required>
        <div class="img-control">
          <div class="img-box" v-if="form.img">
            <img :src="form.img" alt="图片" />
            <span class="clear-img" @click="handleClearImg">X</span>
          </div>
          <Upload ref="uploadRef" :text="'，图片尺寸为836px * 458px'" v-model="form.img" />
        </div>
      </el-form-item>
      <el-form-item label="正文" required>
        <QuillEditor
          ref="editorRef"
          v-model="form.content"
        />
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button size="small" type="primary" @click="handlePreview(true)">
        预览
      </el-button>
      <el-button class="search-but1" size="small" @click="handleClose(false, form.infoContent)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
    <InformationPreview
      v-if="previewFlag"
      :handleClose="handlePreview"
      :viewData="form"
    />
  </el-dialog>
</template>
<script>
import QuillEditor from '../../components/QuillEditor/index.vue'
import QuillEditor2 from '../../components/QuillEditor/index2.vue'
import Upload from './module/upload.vue'
import * as API from '@/api/veteran/index'
import InformationPreview from './infoPreview.vue'
import { tagList } from './assets'

export default {
  props: ['dialogTitle', 'handleClose', 'defaultData', 'typeId', 'close'],
  name: 'IntroduceDialog',
  components: { Upload, QuillEditor, QuillEditor2, InformationPreview },
  data() {
    return {
      form: {
        ...this.defaultData
      },
      previewFlag: false
    }
  },
  created() {
    if (this.defaultData.classifyIds) {
      const r = this.defaultData.classifyIds.split(',')
      this.form.classifyIds = r.map(item => Number(item))
    }
  },
  computed: {
    tagList () {
      return tagList.filter(({ value }) => value !== this.typeId)
    },
    defaultTag () {
      const t = tagList.find(({ value }) => value === this.typeId)
      if (t) {
        return t.label
      }
      return ''
    }
  },
  methods: {
    async handleSubmit() {
      const { dialogTitle, typeId, form } = this
      const { title, img, content } = form
      if (!(title && img && content)) {
        this.$message.warning('请填写必填项，再继续保存')
        return
      }
      if (title === '<p><br></p>' || content === '<p><br></p>') {
        return this.$message.warning('请填写必填项，再继续保存')
      }
      try {
        const data = {
          type: typeId,
          ...form
        }
        const { code } = await API.veteranManage(data)
        if (code === 0) {
          this.$message.success('保存成功')
          this.close(dialogTitle === '新建资讯' ? 'reset' : 'update')
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleClearImg() {
      this.$set(this.form, 'img', '')
    },
    handlePreview(bool) {
      if (bool) {
        const { title, img, content } = this.form
        if (
          !(title && img && content)
        ) {
          this.$message.warning('请填写必填项，再预览')
          return
        }
      }
      this.previewFlag = bool
    }
  }
}
</script>
<style lang="scss" scoped>
.text-red {
  color: red;
}
.img-control {
  display: flex;
  .img-box {
    position: relative;
    margin-right: 10px;
    > img {
      width: 360px;
      height: 180px;
    }
    .clear-img {
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      border: 1px solid #333;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.write-footer {
  text-align: right;
}
</style>
